




































































































import { Component } from 'vue-property-decorator'
import MainHeader from '@/components/MainHeader.vue' // @ is an alias to /src
import Projects from '@/components/Projects.vue'
import AboutMe from '@/components/AboutMe.vue'
import WorkExp from '@/components/WorkExp.vue'
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import './assets/css/style.scss'

Vue.use(BootstrapVue)

@Component({
  components: {
    MainHeader,
    Projects,
    AboutMe,
    WorkExp
  }
})
export default class Home extends Vue {}
